import React from 'react';
import { Popover } from '@material-ui/core';
import { DateTime } from 'luxon';
import Calendar, { CalendarControls, } from '../Calendar';
var DatePickerCalendar = function (_a) {
    var anchorEl = _a.anchorEl, date = _a.date, monthDate = _a.monthDate, open = _a.open, onClose = _a.onClose, onChange = _a.onChange, onMonthChange = _a.onMonthChange;
    return (React.createElement(Popover, { open: open, anchorEl: anchorEl, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, onClose: onClose },
        React.createElement(CalendarControls, { date: monthDate, onChange: function (action) {
                // @TODO : Date logic shouldnt live here, ideally live inside of useValidDate or date utility
                var newDate = new Date();
                if (action !== 'today') {
                    var d = DateTime.fromJSDate(monthDate);
                    newDate = d[action]({ months: 1 }).toJSDate();
                }
                if (onMonthChange)
                    onMonthChange(newDate);
            } }),
        React.createElement(Calendar, { date: date, month: monthDate, onChange: onChange })));
};
export default DatePickerCalendar;
